import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.scss";
import Select from "../../CoreComponent/Select";

const ClosingDateForm = () => {
  // Original form states
  const [type, setType] = useState("");
  const [closingDate, setClosingDate] = useState("");
  const [conferenceId, setConferenceId] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [allConference, setAllConference] = useState([]);

  // Update form states
  const [closingDatesData, setClosingDatesData] = useState([]);
  const [selectedClosingDateId, setSelectedClosingDateId] = useState("");
  const [type2, setType2] = useState("");
  const [closingDate2, setClosingDate2] = useState("");
  const [conferenceId2, setConferenceId2] = useState("");
  const [error2, setError2] = useState("");
  const [success2, setSuccess2] = useState(false);

  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const GetAPI = "https://eventscons.com/eventbackendnew/api/closing/date";
  const UpdateAPI = "https://eventscons.com/eventbackendnew/api/closing-date/update/";

  // ✅ HELPER FUNCTION - Database time EXACT format (NO timezone shift!)
  const formatDatabaseTime = (dbTimeString) => {
    if (!dbTimeString) return "";
    
    let timeStr = dbTimeString;
    
    // "2026-02-23 12:02:00" → "2026-02-23T12:02"
    if (timeStr.includes(' ')) {
      timeStr = timeStr.split(' ')[0] + 'T' + timeStr.split(' ')[1].slice(0, 5);
    }
    
    // "2026-02-23T12:02:00.000000Z" → "2026-02-23T12:02"
    if (timeStr.includes('T')) {
      timeStr = timeStr.slice(0, 16);
    }
    
    return timeStr;
  };

  // ✅ Current datetime helper
  const getCurrentDateTimeLocal = () => {
    const now = new Date();
    now.setSeconds(0, 0);
    return now.toISOString().slice(0, 16);
  };

  const minDateTime = getCurrentDateTimeLocal();

  // Fetch all conferences
  const getConference = () => {
    const token = localStorage.getItem("token");
    const url = `${BaseUrl}/conferences/all`;

    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAllConference(
          response.data.data?.map((item) => ({
            label: item?.title,
            value: item?.id,
          }))
        );
      })
      .catch(() => {
        setError("Error fetching conferences");
      });
  };

  // ✅ SHOW ALL CLOSING DATES (No future filter) + Sort newest first
  const fetchClosingDates = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(GetAPI, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      let allDates = response.data?.data || [];
      
      // ✅ SORT BY DATE (Newest first)
      allDates.sort((a, b) => new Date(b.closing_date) - new Date(a.closing_date));
      
      setClosingDatesData(allDates);
      console.log("✅ Total Closing Dates Loaded:", allDates.length);
    } catch (error) {
      console.error("Closing dates error:", error);
      setError2("Failed to load closing dates");
    }
  };

  useEffect(() => {
    getConference();
    fetchClosingDates();
  }, []);

  // Original form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      setError("You must be logged in.");
      return;
    }
    if (!conferenceId) {
      setError("Please select a conference.");
      return;
    }

    try {
      await axios.post(
        `${BaseUrl}/closing/date`,
        { type, closing_date: closingDate, conference_id: conferenceId.value },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSuccess(true);
      setError("");
      setType("");
      setClosingDate("");
      setConferenceId("");
      fetchClosingDates(); // Refresh list
    } catch (error) {
      setError(error.response?.data?.message || "Failed to save closing date");
      setSuccess(false);
    }
  };

  // ✅ FIXED SELECT HANDLER - NO TIMEZONE SHIFT!
  const handleSelectClosingDate = (e) => {
    const id = e.target.value;
    setSelectedClosingDateId(id);

    if (id) {
      const selectedData = closingDatesData.find((item) => item.id == id);
      if (selectedData) {
        setType2(selectedData.type);
        
        // ✅ DATABASE TIME EXACTLY AS-IS (12:02 rahega 12:02!)
        setClosingDate2(formatDatabaseTime(selectedData.closing_date));
        
        const conf = allConference.find((c) => c.value == selectedData.conference_id);
        setConferenceId2(conf || null);
      }
    } else {
      setType2("");
      setClosingDate2("");
      setConferenceId2("");
    }
  };

  // Update form submit
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      setError2("You must be logged in.");
      return;
    }
    if (!selectedClosingDateId) {
      setError2("Please select a closing date to update.");
      return;
    }

    try {
      await axios.post(
        `${UpdateAPI}${selectedClosingDateId}`,
        {
          type: type2,
          closing_date: closingDate2,
          conference_id:
            conferenceId2?.value ||
            closingDatesData.find((item) => item.id == selectedClosingDateId)
              ?.conference_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setSuccess2(true);
      setError2("");
      setSelectedClosingDateId("");
      setType2("");
      setClosingDate2("");
      setConferenceId2("");
      fetchClosingDates(); // Refresh list
    } catch (error) {
      setError2(error.response?.data?.message || "Failed to update closing date");
      setSuccess2(false);
    }
  };

  return (
    <div className="closing-date-container">
      {/* ✅ Latest closing date card */}
      <div
        style={{
          background: "#f8f9fa",
          padding: "25px",
          borderRadius: "12px",
          marginBottom: "30px",
          border: "2px solid #9B1321",
          textAlign: "center",
        }}
      >
        <h3 style={{ color: "#9B1321", marginBottom: "20px" }}>
          📋 Latest Closing Date (Total: {closingDatesData.length})
        </h3>

        {closingDatesData.length === 0 ? (
          <div style={{ color: "#666", padding: "20px" }}>
            No closing dates found
          </div>
        ) : (
          <div
            style={{
              background: "linear-gradient(135deg, #9B1321, #c62828)",
              color: "white",
              padding: "20px",
              borderRadius: "12px",
            }}
          >
            <div style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "10px" }}>
              {closingDatesData[0].type?.toUpperCase()}
            </div>
            <div style={{ fontSize: "18px", marginBottom: "5px" }}>
              Conference ID: {closingDatesData[0].conference_id}
            </div>
            <div style={{ fontSize: "16px" }}>
              {/* ✅ EXACT DATABASE TIME! */}
              {formatDatabaseTime(closingDatesData[0].closing_date)}
            </div>
            <div style={{ fontSize: "12px", opacity: 0.9, marginTop: "10px" }}>
              ID: {closingDatesData[0].id}
            </div>
          </div>
        )}
      </div>

      {/* Forms side by side */}
      <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
        {/* Original form */}
        <div style={{ flex: 1, minWidth: "400px" }}>
          <h2 style={{ color: "#9B1321" }}>Set New Closing Date</h2>

          <form onSubmit={handleSubmit}>
            {success && (
              <div className="alert success" style={{ 
                background: "#d4edda", 
                color: "#155724", 
                padding: "12px", 
                borderRadius: "6px", 
                marginBottom: "15px",
                border: "1px solid #c3e6cb"
              }}>
                Closing Date Saved Successfully!
              </div>
            )}
            {error && (
              <div className="alert error" style={{ 
                background: "#f8d7da", 
                color: "#721c24", 
                padding: "12px", 
                borderRadius: "6px", 
                marginBottom: "15px",
                border: "1px solid #f5c6cb"
              }}>
                ❌ {error}
              </div>
            )}

            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label htmlFor="type" style={{ display: "block", marginBottom: "8px", fontWeight: "bold", color: "#333" }}>
                Type:
              </label>
              <select
                id="type"
                value={type}
                onChange={(e) => setType(e.target.value)}
                style={{ 
                  width: "100%", 
                  padding: "12px", 
                  borderRadius: "8px", 
                  border: "2px solid #ddd",
                  fontSize: "14px"
                }}
                required
              >
                <option value="">Select Type</option>
                <option value="abstract">📄 Abstract</option>
                <option value="accommodation">🏨 Accommodation</option>
                <option value="registration">📝 Registration</option>
              </select>
            </div>

            <div className="form-group" style={{ marginBottom: "20px" }}>
              <Select
                options={allConference}
                value={conferenceId}
                setValue={setConferenceId}
                label="Select Conference"
                placeholder="Select..."
              />
            </div>

            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label htmlFor="closing_date" style={{ display: "block", marginBottom: "8px", fontWeight: "bold", color: "#333" }}>
                Closing Date & Time:
              </label>
              <input
                type="datetime-local"
                id="closing_date"
                value={closingDate}
                onChange={(e) => setClosingDate(e.target.value)}
                min={minDateTime}
                style={{ 
                  width: "100%", 
                  padding: "12px", 
                  borderRadius: "8px", 
                  border: "2px solid #ddd",
                  fontSize: "14px"
                }}
                required
              />
            </div>

            <button
              style={{ 
                background: "linear-gradient(135deg, #9B1321, #c62828)",
                color: "white", 
                padding: "15px 30px", 
                borderRadius: "10px", 
                border: "none", 
                fontSize: "16px", 
                fontWeight: "bold",
                cursor: "pointer",
                width: "100%",
                boxShadow: "0 4px 15px rgba(155, 19, 33, 0.3)"
              }}
              type="submit"
              className="btn-submit"
            >
              💾 Save Closing Date
            </button>
          </form>
        </div>

        {/* Update form */}
        <div style={{ flex: 1, minWidth: "400px" }}>
          <h2 style={{ color: "#9B1321" }}>Update Closing Date</h2>

          <form onSubmit={handleUpdateSubmit}>
            {success2 && (
              <div className="alert success" style={{ 
                background: "#d4edda", 
                color: "#155724", 
                padding: "12px", 
                borderRadius: "6px", 
                marginBottom: "15px",
                border: "1px solid #c3e6cb"
              }}>
                Closing Date Updated Successfully!
              </div>
            )}
            {error2 && (
              <div className="alert error" style={{ 
                background: "#f8d7da", 
                color: "#721c24", 
                padding: "12px", 
                borderRadius: "6px", 
                marginBottom: "15px",
                border: "1px solid #f5c6cb"
              }}>
                ❌ {error2}
              </div>
            )}

            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label htmlFor="select-closing-date" style={{ display: "block", marginBottom: "8px", fontWeight: "bold", color: "#333" }}>
                📋 Select Closing Date (Total: {closingDatesData.length}):
              </label>
              <select
                id="select-closing-date"
                value={selectedClosingDateId}
                onChange={handleSelectClosingDate}
                required
                style={{ 
                  width: "100%", 
                  padding: "14px", 
                  borderRadius: "10px",
                  border: "2px solid #ddd",
                  fontSize: "14px",
                  backgroundColor: "#f9f9f9"
                }}
              >
                <option value="">Choose closing date...</option>
                {closingDatesData.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.type.toUpperCase()} - Conf #{item.conference_id} -{" "}
                    {formatDatabaseTime(item.closing_date)}{' '}
                    {new Date(item.closing_date) < new Date() && '(PAST)'}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label htmlFor="type2" style={{ display: "block", marginBottom: "8px", fontWeight: "bold", color: "#333" }}>
                Type:
              </label>
              <select
                id="type2"
                value={type2}
                onChange={(e) => setType2(e.target.value)}
                style={{ 
                  width: "100%", 
                  padding: "12px", 
                  borderRadius: "8px", 
                  border: "2px solid #ddd",
                  fontSize: "14px"
                }}
                required
              >
                <option value="">Select Type</option>
                <option value="abstract">📄 Abstract</option>
                <option value="accommodation">🏨 Accommodation</option>
                <option value="registration">📝 Registration</option>
              </select>
            </div>

            <div className="form-group" style={{ marginBottom: "20px" }}>
              <Select
                options={allConference}
                value={conferenceId2}
                setValue={setConferenceId2}
                label="Select Conference"
                placeholder="Select..."
              />
            </div>

            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label htmlFor="closing_date2" style={{ display: "block", marginBottom: "8px", fontWeight: "bold", color: "#333" }}>
                Closing Date & Time:
              </label>
              <input
                type="datetime-local"
                id="closing_date2"
                value={closingDate2}
                onChange={(e) => setClosingDate2(e.target.value)}
                min={minDateTime}
                style={{ 
                  width: "100%", 
                  padding: "12px", 
                  borderRadius: "8px", 
                  border: "2px solid #ddd",
                  fontSize: "14px"
                }}
                required
              />
            </div>

            <button
              style={{ 
                background: "linear-gradient(135deg, #9B1321, #c62828)",
                color: "white", 
                padding: "15px 30px", 
                borderRadius: "10px", 
                border: "none", 
                fontSize: "16px", 
                fontWeight: "bold",
                cursor: "pointer",
                width: "100%",
                boxShadow: "0 4px 15px rgba(155, 19, 33, 0.3)"
              }}
              type="submit"
              className="btn-submit"
            >
              🔄 Update Closing Date
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ClosingDateForm;